/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case-insensitive`)
};

const es_fr_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin distinción de mayúsculas`)
};

const de_fr_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groß-/Kleinschreibung ignorieren`)
};

const nl_fr_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet-hoofdlettergevoelig`)
};

const fr_fr_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insensible à la casse`)
};

const it_fr_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maiuscole/minuscole non sensibili`)
};

const pt_br2_fr_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem distinção de maiúsculas/minúsculas`)
};

const pt_fr_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem distinção de maiúsculas`)
};

const ja_fr_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大文字と小文字を区別しない`)
};

const zh_fr_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不区分大小写`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_case = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_case(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_case", locale)
	if (locale === "en") return en_fr_case(inputs)
	if (locale === "es") return es_fr_case(inputs)
	if (locale === "de") return de_fr_case(inputs)
	if (locale === "nl") return nl_fr_case(inputs)
	if (locale === "fr") return fr_fr_case(inputs)
	if (locale === "it") return it_fr_case(inputs)
	if (locale === "pt-BR") return pt_br2_fr_case(inputs)
	if (locale === "pt") return pt_fr_case(inputs)
	if (locale === "ja") return ja_fr_case(inputs)
	return zh_fr_case(inputs)
};